import { Component } from '@angular/core';
import { SideNavService } from '../admin/services/side-nav.service';
import { CommunityGroupService } from './community-group.service';

@Component({
  selector: 'app-community-group-create',
  styles: [':host { display: block; width: 560px; max-width: 100vw; }'],
  template: '<app-community-group-form [embedded]="true" portal="admin" (saved)="onSaved()"></app-community-group-form>'
})
export class CommunityGroupCreateComponent {
  constructor(private sideNav: SideNavService, private groups: CommunityGroupService) {}
  onSaved(): void {
    this.sideNav.close();
    this.groups.groupCreated$.next();
  }
}
